import { call, put, select } from "redux-saga/effects";
import { setSaveLater_, getSaveLaterFail_ } from "../../ducks/saveLaterSlice";
import { requestGetSaveLater } from "../requests/savelater";
export const getSaveLater = (state) => state.saveLater;

export function* handleGetSaveLater(action) {
	try {
		const saveLater = yield select(getSaveLater);
		if (saveLater?.savelater_id) {
			const response = yield call(requestGetSaveLater, saveLater.savelater_id);
			const { data } = response;
			yield put(setSaveLater_({ product: data.records }));
		}
	} catch (error) {
		yield put(
			getSaveLaterFail_({ message: error.message, response: error.response })
		);
	}
}
